export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification, bind} from 'kpc';

interface Props {
    notificationId?: number 
}

export default class extends Component<Props> {
    static template = template;
    
    static defaults() {
        return {
            notificationId: undefined
        }
    }
    
    @bind
    showNotification() {
        const id = Notification.info({
            title: '可关闭的通知',
            content: '点击"关闭通知"按钮可以关闭此通知',
            duration: 0,
        });
        this.set('notificationId', id);
    }

    @bind
    closeNotification() {
        const notificationId = this.get('notificationId');
        if (notificationId !== undefined) {
            Notification.close(notificationId as number);
            this.set('notificationId', undefined);
        }
    }
}